module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Spreitenbach_AG-2fb21fa9a8bf802dc0beccce93400653.svg";